import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Chip, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const AllRequestAppliedFiltersBar = ({
  chips = [],
  fromDashboard = false,
  onRemoveChip,
  onClearAll,
}) => {
  if (!chips.length && !fromDashboard) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
        {fromDashboard ? (
          <Button
            component={RouterLink}
            to="/SLN/Management"
            size="small"
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            sx={{ mr: 0.5 }}
          >
            بازگشت به داشبورد
          </Button>
        ) : null}

        {chips.map((chip) => (
          <Chip
            key={chip.key}
            label={chip.label}
            size="small"
            onDelete={() => onRemoveChip?.(chip)}
            deleteIcon={<CloseIcon />}
            variant="outlined"
          />
        ))}

        {chips.length > 1 ? (
          <Button size="small" onClick={onClearAll}>
            پاک کردن همه فیلترها
          </Button>
        ) : null}
      </Stack>
    </Box>
  );
};

export default AllRequestAppliedFiltersBar;
